import axios from "axios";
import { Constants } from "../components/Common/Constants";

class HttpService {
  defaultOptions = () => {
    return {
      baseURL: `${process.env.REACT_APP_API_URL}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(Constants.accessToken)}`,
      },
    };
  };

  defaultOptionsFormdata = () => {
    return {
      baseURL: `${process.env.REACT_APP_API_URL}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(Constants.accessToken)}`,
        "Content-Type": "multipart/form-data",
      },
    };
  };

  successResult = (res, method = "GET") => {
    if (method === "DELETE" && res.status >= 200 && res.status < 300) {
      return {
        status: true,
        data: res.data,
        statusCode: res.status
      };
    }
    if (res.data && (res.data.status === true || res.status === 200 || res.status === 201)) {
      return {
        status: true,
        data: res.data,
        statusCode: res.status
      };
    } else {
      return {
        status: false,
        data: Constants.somethingWentWrong,
        message: res.data?.message || Constants.somethingWentWrong,
        error: res.data?.error || {},
        statusCode: res.status
      };
    }
  };

  /* successResult = (res) => {
    console.log("on success::",res.data.status);
    if (res.data && res.data.status === true) {
      return { status: true, data: res.data };
    } else {
      return { status: false, data: Constants.somethingWentWrong };
    }
  }; */

  successResultNew = (res) => {
    console.log("on success::", res.data.status);
    if (res.data) {
      return { status: true, data: res.data };
    } else {
      return { status: false, data: Constants.somethingWentWrong };
    }
  };

  failureResult = (err) => {
    if (err?.response?.status === 401) {
      localStorage.clear();
      window.location = "/sign-in";
    }

    const data = { status: false };

    try {
      // Set default error message
      data.error = err.message;
      data.message = err.message;
      data.statusCode = err?.response?.status;
      if (err.response && err.response.data) {
        // If API returns structured error response
        data.error = err.response.data.error || err.response.data;
        data.message = err.response.data.message || err.response.data.error || err.message;
      }
      return data;
    } catch (error) {
      data.error = error.message;
      data.message = error.message;
      return data;
    }
  };

  get = async (url, options = {}) => {
    try {
      const res = await axios.get(url, {
        ...this.defaultOptions(),
        ...options,
      });
      return this.successResult(res, "GET");
    } catch (err) {
      return this.failureResult(err);
    }
  };

  post = async (url, data, options = {}) => {
    try {
      const res = await axios.post(url, data, {
        ...this.defaultOptions(),
        ...options,
      });
      return this.successResult(res, "POST");
    } catch (err) {
      return this.failureResult(err);
    }
  };

  put = async (url, data, options = {}) => {
    try {
      const res = await axios.put(url, data, {
        ...this.defaultOptions(),
        ...options,
      });
      return this.successResult(res, "PUT");
    } catch (err) {
      return this.failureResult(err);
    }
  };

  postForm = async (url, data, options = {}) => {
    try {
      const res = await axios.post(url, data, {
        ...this.defaultOptionsFormdata(),
        ...options,
      });
      return this.successResult(res, "POST");
    } catch (err) {
      return this.failureResult(err);
    }
  };

  patch = async (url, data, options = {}) => {
    try {
      const res = await axios.patch(url, data, {
        ...this.defaultOptions(),
        ...options,
      });
      return this.successResult(res, "PATCH");
    } catch (err) {
      return this.failureResult(err);
    }
  };

  postNew = async (url, data, options = {}) => {
    try {
      const res = await axios.post(url, data, {
        ...this.defaultOptions(),
        ...options,
      });
      return this.successResultNew(res, "POST");
    } catch (err) {
      return this.failureResult(err);
    }
  };

  patchNew = async (url, data, options = {}) => {
    try {
      const res = await axios.patch(url, data, {
        ...this.defaultOptions(),
        ...options,
      });
      console.log("service res::", res.data);
      return this.successResultNew(res, "PATCH");
    } catch (err) {
      return this.failureResult(err);
    }
  };

  delete = async (url, data, options = {}) => {
    try {
      const res = await axios.delete(url, {
        ...this.defaultOptions(),
        data,
        ...options,
      });
      return this.successResult(res, "DELETE");
    } catch (err) {
      return this.failureResult(err);
    }
  };
}

const httpServiceInstance = new HttpService();

export default httpServiceInstance;
